/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { agentSchedulesResumeAgentSchedule } from "../../funcs/agentSchedulesResumeAgentSchedule.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ResumeAgentScheduleRequest$inboundSchema,
};

export const tool$agentSchedulesResumeAgentSchedule: ToolDefinition<
  typeof args
> = {
  name: "agent-schedules-resume-agent-schedule",
  description: `Resume an agent schedule`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await agentSchedulesResumeAgentSchedule(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
